@if (context.footers?.length) {
<div class="ag-status-name-value ag-status-panel">
  <div fxLayout="row" fxLayoutGap="8px">
    @for (footer of context.footers; track footer.label) {
    <div>
      {{ footer.label }}: <b>{{ footer.value($selectedData()) | async }}</b>
    </div>
    }
  </div>
</div>
}
